import React from 'react';
import { FaThumbsUp, FaShare, FaBookmark, FaEye, FaUsers, FaPhotoVideo, FaRegCommentDots, FaChartLine, FaPlayCircle } from 'react-icons/fa';
import { StatsContainer, ClickableStatCard, StatInfo } from '../styles';

const StatsCards = ({ metrics, pageMetrics, filtros, navigate }) => {
    
    // Formata números grandes (ex: 1500 -> 1.5k) se desejar, ou usa toLocaleString
    const formatNumber = (num) => {
        return num ? num.toLocaleString('pt-BR') : 0;
    };

    return (
        <StatsContainer>
            {/* Seguidores: Se 'todas', mostra a soma. Se 'uma', permite clicar para ver histórico */}
            <ClickableStatCard 
                color="#1DA1F2" 
                isClickable={filtros.pagina !== 'todas'} 
                onClick={filtros.pagina !== 'todas' ? () => navigate(`/trends/page/${filtros.pagina}/followers_count`) : null}
            >
                <FaUsers />
                <StatInfo>
                    <h4>Seguidores</h4>
                    <p>{formatNumber(pageMetrics?.followers_count)}</p>
                </StatInfo>
            </ClickableStatCard>
            
            {/* Total Mídias: Mostra o total no período filtrado */}
            <ClickableStatCard 
                color="#8A3AB9" 
                isClickable={filtros.pagina !== 'todas'} 
                onClick={filtros.pagina !== 'todas' ? () => navigate(`/trends/page/${filtros.pagina}/media_count`) : null}
            >
                <FaPhotoVideo />
                <StatInfo>
                    <h4>Mídias (Período)</h4>
                    <p>{formatNumber(pageMetrics?.media_count)}</p>
                </StatInfo>
            </ClickableStatCard>

            {/* Restante dos cards permanece igual... */}
            <ClickableStatCard color="#28a745" isClickable={filtros.post !== 'todos'} onClick={filtros.post !== 'todos' ? () => navigate(`/trends/post/${filtros.post}/reach`) : null}>
                <FaChartLine />
                <StatInfo><h4>Alcance</h4><p>{formatNumber(metrics.reach)}</p></StatInfo>
            </ClickableStatCard>

            <ClickableStatCard color="#3b5998" isClickable={filtros.post !== 'todos'} onClick={filtros.post !== 'todos' ? () => navigate(`/trends/post/${filtros.post}/likes`) : null}>
                <FaThumbsUp />
                <StatInfo><h4>Curtidas</h4><p>{formatNumber(metrics.likes)}</p></StatInfo>
            </ClickableStatCard>

            <ClickableStatCard color="#55acee" isClickable={filtros.post !== 'todos'} onClick={filtros.post !== 'todos' ? () => navigate(`/trends/post/${filtros.post}/comments`) : null}>
                <FaRegCommentDots />
                <StatInfo><h4>Comentários</h4><p>{formatNumber(metrics.comments)}</p></StatInfo>
            </ClickableStatCard>

            <ClickableStatCard color="#0077b5" isClickable={filtros.post !== 'todos'} onClick={filtros.post !== 'todos' ? () => navigate(`/trends/post/${filtros.post}/shares`) : null}>
                <FaShare />
                <StatInfo><h4>Compart.</h4><p>{formatNumber(metrics.shares)}</p></StatInfo>
            </ClickableStatCard>

            <ClickableStatCard color="#c32aa3" isClickable={filtros.post !== 'todos'} onClick={filtros.post !== 'todos' ? () => navigate(`/trends/post/${filtros.post}/saves`) : null}>
                <FaBookmark />
                <StatInfo><h4>Salvos</h4><p>{formatNumber(metrics.saves)}</p></StatInfo>
            </ClickableStatCard>

            <ClickableStatCard color="#e52d27" isClickable={filtros.post !== 'todos'} onClick={filtros.post !== 'todos' ? () => navigate(`/trends/post/${filtros.post}/views`) : null}>
                {filtros.tipo === 'REELS' ? <FaPlayCircle /> : <FaEye />}
                <StatInfo><h4>{filtros.tipo === 'REELS' ? 'Plays' : 'Views + Plays'}</h4><p>{formatNumber(metrics.views + metrics.plays)}</p></StatInfo>
            </ClickableStatCard>
        </StatsContainer>
    );
};

export default StatsCards;